import { DashboardState, DateFilterTypeEnum } from "../types";

export const initialState: DashboardState = {
  filterValue: DateFilterTypeEnum.TODAY,
  startDate: new Date(),
  endDate: new Date(),
  DashboardFormData: {
    userCount: 0,
    previousUserCount: 0,
    orderCount: 0,
    previousOrderCount: 0,
    totalPayment: 0,
    previousTotalPayment: 0,
  },
  chartData: {
    date: [],
    user: [],
    order: [],
    payment: [],
  },
};
